import BaseListStore from './BaseListStore';

class NotificationsStoreClass extends BaseListStore {}
const PaymentsStore = new NotificationsStoreClass('payments', '', {});
export default PaymentsStore;
